import SuppliersListContainer from "../../../components/asset-management/SuppliersList";

export default function Suppliers() {
  return <SuppliersListContainer />;
}
